import React from 'react';
export function Footer() {
  return <footer className="w-full bg-cream px-4 pb-32 pt-10 text-center" data-id="element-140" data-mp="19ivlq3plplne">
      <p className="font-display text-base font-bold uppercase tracking-[0.22em] text-gold-dark" data-id="element-141" data-mp="206j3niyycbee">
        Dr. Karito
      </p>
      <p className="mt-2 text-[12px] text-ink-soft" data-id="element-142" data-mp="2f421rbxis0yi">
        Clinical Certainty Protocol™ · Clinical educational material
      </p>
      <p className="mx-auto mt-4 max-w-md text-[11px] leading-relaxed text-ink-soft/80" data-id="element-143" data-mp="1mg5vpgm28wp2">
        This product is digital educational material and does not replace professional clinical
        judgment. Results depend on each clinician’s individual application.
      </p>
      <p className="mt-4 text-[11px] text-ink-soft/70" data-id="element-144" data-mp="1w7aaogbqkhjw">
        © {new Date().getFullYear()} Dr. Karito. All rights reserved.
      </p>
    </footer>;
}